var map = {
	"./ArtCraft1.jpeg": 1783,
	"./ArtCraft2.jpeg": 9850,
	"./ArtCraft3.jpeg": 9697,
	"./ArtCraft4.jpeg": 8500,
	"./ArtCraft5.jpeg": 6011,
	"./ArtCraft6.jpeg": 1950,
	"./ArtCraft7.jpeg": 4437,
	"./WhatsApp Image 2026-03-17 at 1.16.15 PM.jpeg": 3285,
	"./WhatsApp Image 2026-03-17 at 1.16.19 PM.jpeg": 5430,
	"./WhatsApp Image 2026-03-17 at 1.16.21 PM.jpeg": 5096,
	"./WhatsApp Image 2026-03-17 at 1.16.22 PM.jpeg": 8863,
	"./WhatsApp Image 2026-03-17 at 1.16.28 PM.jpeg": 4381,
	"./WhatsApp Image 2026-03-17 at 1.16.44 PM.jpeg": 8275
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6095;